import React from 'react';
import { Helmet } from 'react-helmet';
import { schemaOrgWebPage } from '../../utils/ld';
import Facebook from './Facebook';
import Twitter from './Twitter';
function toTitle(title, defaultTitle) {
    if (defaultTitle) {
        return title ? "".concat(title, " : ").concat(defaultTitle) : defaultTitle;
    }
    return title || '';
}
var SEO = function (_a) {
    var title = _a.title, 
    // pathname,
    url = _a.url, defaultTitle = _a.defaultTitle, defaultDescription = _a.defaultDescription, description = _a.description, 
    // siteUrl,
    defaultBanner = _a.defaultBanner, language = _a.language, twitter = _a.twitter, facebook = _a.facebook, buildTime = _a.buildTime, canonical = _a.canonical, disableDefaultDescription = _a.disableDefaultDescription;
    var seo = {
        title: toTitle(title, defaultTitle),
        description: disableDefaultDescription ? description : description || defaultDescription,
        image: "".concat(defaultBanner),
        url: url || '',
        canonical: canonical,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, { title: seo.title || '' },
            React.createElement("html", { lang: language || 'ja' }),
            seo.description && React.createElement("meta", { name: "description", content: seo.description }),
            React.createElement("meta", { name: "image", content: seo.image }),
            seo.canonical && React.createElement("link", { rel: "canonical", href: seo.canonical }),
            React.createElement("script", { type: "application/ld+json" }, JSON.stringify(schemaOrgWebPage(url, language, defaultDescription, defaultTitle, buildTime, seo.image)))),
        React.createElement(Facebook, { description: seo.description || '', image: seo.image, title: seo.title || '', type: 'website', url: seo.url, name: facebook || '' }),
        React.createElement(Twitter, { title: seo.title || '', image: seo.image, description: seo.description || '', username: twitter || '' })));
};
export default SEO;
//# sourceMappingURL=SEO.js.map